import { render, staticRenderFns } from "./IP_DxSummaryPrintable.vue?vue&type=template&id=8ee918c6&scoped=true&"
import script from "./IP_DxSummaryPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_DxSummaryPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_DxSummaryPrintable.vue?vue&type=style&index=0&id=8ee918c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee918c6",
  null
  
)

export default component.exports